<template>
  <article class="new_login new_signup">
    <section class="trainers__header">
      <div class="trainers__header--title">
        <p style="width:100%">Nuevo empleado</p>
        <v-breadcrumbs style="width: 100%">
          <v-icon slot="divider">chevron_right</v-icon>
          <v-breadcrumbs-item
            @click="$router.push({name: 'employees'})">
            Empleados
          </v-breadcrumbs-item>
          <v-breadcrumbs-item
            disabled>
            Nuevo empleado
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </div>
    </section>

    <section>
      <div class="agreement__new">
        <div class="agreement__new--column">
          <p class="agreement__text--small_gray">Nombre</p>
          <v-text-field
            name="employee_name"
            single-line
            v-validate="'required|alpha_spaces'"
            label="Nombre"
            type="text"
            v-model="data.attributes.user_info_attributes.name">
          </v-text-field>
          <p  :class="errors.has('employee_name')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('organization_name')?'El nombre de la empresa es requerido':''}}</p>
          <p class="agreement__text--small_gray">Apellido</p>
          <v-text-field
            name="employee_last_name"
            single-line
            label="Apellido"
            type="text"
            v-validate="'required|alpha_spaces'"
            v-model="data.attributes.user_info_attributes.last_name">
          </v-text-field>
           <p  :class="errors.has('employee_last_name')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('user_name')?'El nombre del usuario encargado es incorrecto':''}}</p>


          <p class="agreement__text--small_gray">Contraseña</p>
          <v-text-field
            single-line
            name="password"
            label="Crear contraseña"
            :append-icon="eye ? 'visibility' : 'visibility_off'"
            :type="eye ? 'text' : 'password'"
            @click:append="eye = !eye"
            v-validate="{required: true, regex:/^.{6,}$/}"
            v-model="data.attributes.password">
          </v-text-field>
          <p  :class="errors.has('password')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('password')?'La contraseña debe tener al menos 6 dígitos':''}}</p>
          <p class="agreement__text--small_gray">Teléfono</p>
          <v-text-field
            single-line
            name="phone"
            label="Teléfono"
            v-validate="'numeric|min_value:0'"
            type="number"
            v-model="data.attributes.mobile">
          </v-text-field>
            <p  :class="errors.has('phone')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('quantity')?'El número de pases es incorrecto':''}}</p>
        </div>
        <div class="agreement__new--column">
          <p class="agreement__text--small_gray">RUT</p>
          <v-text-field
            single-line
            name="rut"
            label="Cédula"
            v-validate="'required'"
            type="text"
            v-model="data.attributes.rut">
          </v-text-field>
          <p  :class="errors.has('rut')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('nit')?'El NIT es requerido':''}}</p>
          <p class="agreement__text--small_gray">Correo electrónico</p>
          <v-text-field
            single-line
            name="email"
            v-validate="{required: true, regex:/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/}"
            label="Correo electrónico"
            type="text"
            v-model="data.attributes.email">
          </v-text-field>
          <p  :class="errors.has('email')?'agreement__new--error_container':'agreement__new--space'">{{this.errors.has('email')?'EL formato del correo es incorrecto':''}}</p>
          <p class="agreement__text--small_gray">Sexo</p>
          <v-radio-group v-model="data.attributes.user_info_attributes.gender" :mandatory="false">
            <v-radio label="Hombre" value="Male"></v-radio>
            <v-radio label="Mujer" value="Female"></v-radio>
          </v-radio-group>
          <v-hover>
            <div slot-scope="{ hover }" @click="submit_form()" :class="hover?'agreement__interaction--hover':''" class="agreement__buttons--create_new">
              <p>CREAR</p>
            </div>
          </v-hover>



        </div>

      </div>
    </section>
  </article>
</template>

<script>
    // import { countries } from '../../../assets/js/countries.js'
    export default{
        data(){
            return {
                eye:false,
                locations: [],
                show_password: true,
                focus: false,
                email_checked: false,
                mobile_checked: false,
                img_src: './src/assets/images/icons/visibility.svg',
                countries: [],
                country_selected: {
                    code: 'CO',
                    dial_code: '+57',
                    name: 'Emiratos Árabes Unidos'
                },
                validator: '',
                password: 'password',
                pass: '',
                validate_rut: false,
                attributes: {
                    password: '',
                    'password-confirmation': '',
                    mobile: '',
                    email: '@gmail.com'
                },
                data: {
                    attributes: {
                        password: '',
                        'password-confirmation': '',
                        mobile: '',
                        email: '',
                        rut: '',
                        user_info_type: 'Employee',
                        user_info_attributes:{
                          name: "",
                          last_name: "",
                          gender: "",
                          birthday: "",
                          location_id: "",
                          type: "Employee"
                        }
                    }
                }
            }
        },
        methods: {
            selectGender(){
              $('.button_selector').removeClass('active');
              $(event.target).addClass('active');
              this.data.attributes.user_info_attributes.gender = $(event.target).attr('data-gender')
            },
            toggle_password_view(){
                this.show_password = !this.show_password;
            },
            toggle_modal(){
                $(this.$el).find("#modal_parent").css("display","block");
            },
            add_password(event,num) {
                if($(event.target).val().length > 1){
                    $(event.target).val($(event.target).val()[0]);
                }
                // Added from walmart
                if($(event.target).val()){
                    if(this.attributes.password.length <= num){
                        this.attributes.password += $(event.target).val();
                    }
                    if($(event.target).next().prop("tagName") != "IMG"){
                        $(event.target).next().focus().click();
                    }
                }else{
                    this.attributes.password = this.attributes.password.slice(0, num)
                        + this.attributes.password.slice(num+1);
                    $(event.target).prev().focus().click();
                }
            },
            submit_form(){
              var rut = this.data.attributes.rut;
              if(this.data.attributes.user_info_attributes.location_id==''){
                this.data.attributes.user_info_attributes.location_id=null
              }
              this.$validator.validateAll().then((result) => {
                // if(rut != ''){
                //   if(this.validator == this.validateRut(rut)){
                //     this.data.attributes.rut = this.data.attributes.rut + this.validator
                //     this.validate_rut = true
                //   } else {
                //     this.validate_rut = false
                //     // alert("El Rut no es correcto, este es el validador correcto " + this.validateRut(rut))
                //     this.updateShowToast(true)
                //   }
                // }else{
                //   this.validate_rut = true
                //   this.data.attributes.rut = null
                // }

                if(this.data.attributes.rut != ''){
                  try{
                    if (result) {
                      this.$http.post("employees/create_employee", {
                          data: this.encrypt(this.data).toString()
                      }, {
                        headers: {
                          "X-Device-ID" : this.getDeviceId(),
                          "Authorization" : 'Bearer ' + this.getUserToken()
                          // "FCM-ID" : this.getFcmId()
                        }
                      }).then(function(response){
                        // if(response.body.meta != undefined && response.body.meta != null){
                        //   // if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        //   //   this.checkToken(response.body.meta.authentication_token)
                        //   // }
                        //   this.updateUserId(response.body.data.id)
                        //   this.updateUserEmail(response.body.data.attributes.email)
                        //   this.updateUserMobile(response.body.data.attributes.mobile)
                        //   this.updateUserName(response.body.included[0].attributes.name)
                        //   this.updateUserLastName(response.body.included[0].attributes.last_name)
                        //   this.updateUserRut(response.body.data.attributes.rut)
                        //   this.updateLocationUser(response.body.included[0].attributes.location_id)
                        //   this.updateUserInfoId(response.body.included[0].id);
                        //   this.create_user_db(this, this.getDB(), response);
                        // }
                          this.$router.push({name: 'employees'})
                      }, function(response){
                        if(typeof response.body.errors[0].details != "object"){
                          alert(response.body.errors[0].details);
                        }else{
                          let message = []
                          for(var key in response.body.errors[0].details){
                            message.push(response.body.errors[0].details[key])
                          }
                          alert(message);
                        }
                        // if(response.body.meta != undefined && response.body.meta != null){
                        //   if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        //     this.checkToken(response.body.meta.authentication_token)
                        //   }
                        // }
                        // if(typeof response.body.errors[0].details != "object"){
                        //   this.data.attributes.rut = this.data.attributes.rut.slice(0, -1);
                        //   alert(response.body.errors[0].details);
                        // }else{
                        //   let message = []
                        //   for(var key in response.body.errors[0].details){
                        //     message.push(response.body.errors[0].details[key])
                        //   }
                        //   if(this.data.attributes.rut != '' &&
                        //      this.data.attributes.rut != undefined &&
                        //      this.data.attributes.rut != null){
                        //     this.data.attributes.rut = this.data.attributes.rut.slice(0, -1);
                        //   }
                        //   alert(message);
                        // }
                      });
                    }
                  }catch(e){
                    alert(e.message);
                  }
                }
              });
            },
            create_email(array){
                var event = array[0];
                var num = array[1];
                switch(num){
                    case 1:
                        var email = this.attributes.email;
                        this.attributes.email = $(event).val() +
                            email.slice(email.indexOf('@'), email.length);
                        break;
                    case 2:
                        var email = this.attributes.email;
                        this.attributes.email =
                            email.slice(0, email.indexOf('@')+1) +
                            $(event).val();
                        if(email.indexOf('.') >= 0){
                            this.attributes.email +=
                                email.slice(email.indexOf('.'), email.length);
                        }
                        break;
                    case 3:
                        var email = this.attributes.email;
                        if(this.attributes.email.indexOf('.') >= 0){
                            this.attributes.email =
                                email.slice(0, email.indexOf('.')) +
                                $(event).val();
                        }else{
                            this.attributes.email += $(event).val();
                        }
                        break;
                    default:
                        break;
                }
            },
            validation(){
                var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                if(re.test($("#validation").val())){
                  this.data.attributes.email = $("#validation").val();
                  this.email_checked = true;
                  this.mobile_checked = false;
                }
            },
            redirect_back(){
                window.history.back();
            },
            date(){
              let today = new Date();
              let last = 1000 * 60 * 60 * 24 * 1825;
              let sub = today.getTime() - last;
              let fe = new Date(sub);
              let f = (fe.getFullYear()+"-"+(fe.getMonth()+1)+"-"+fe.getDate());
              return f;
            }
        },
        watch: {
            show_password(val){
                if(this.show_password){
                    this.img_src = './src/assets/images/icons/visibility.svg';
                    $("#user_password").prop("type",'password');
                }else{
                    this.img_src = './src/assets/images/icons/visibility_off.svg';
                    $("#user_password").prop("type",'text');
                }
            }
        },
        mounted(){
          // cl typeof this.date()
            // this.setupPush();
            // this.init_db();
            try{
                // vm.$http.get(vm.getServer()+"/v1/outlets/my_favorites?page="+vm.actual_page_favourites, {
                this.$http.get("app/locations?page=1&classes=true",
                ).then(function(response){
                    this.locations=response.body.data;
                }, function(response){

                })
            }catch(e){

            }
            // var vue = this;
            // $("#validation").focusin(function(){
            //     vue.focus = true;
            // })
            // $("#validation").focusout(function(){
            //     vue.focus = false;
            // })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/views/employees/NewEmployee.vue